
import {useQuery,useMutation,useQueryClient} from 'react-query';
import{GetAllSimpleCustomers} from '../Api/index';





const useGetAllSimpleCustomers = (body,customizedBody) => {
    let newBody={...body,...customizedBody};
 
    return useQuery(['GetChequeCalenderView',newBody],GetAllSimpleCustomers, {
        refetchOnWindowFocus: false,
        enabled:!!newBody,
        onError: () => {
        
        }
        ,
        onSuccess: (data) => {
      
        }
        ,
       select: (data) => {
         let rawData = data?.data?.data;
         return rawData

       },
    })
}

export {
    useGetAllSimpleCustomers
}